// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"461":"c911f3ea","669":"e2725909"}[chunkId] + ".chunk.js";
};